import Jobs from "../pages/Jobs";

export default function PortalJobsPanel() {
  return (
    <div className="min-h-0 flex-1 bg-[hsl(var(--ds-bg))] text-[hsl(var(--ds-fg))]">
      <Jobs />
    </div>
  );
}
